<router-outlet></router-outlet>
<!-- Once, at the root, so toasts show on the login pages as well. -->
<app-toast-host></app-toast-host>
